import React from 'react';

const TourDetailSkeleton = () => {
  return (
    <div className="min-h-screen animate-pulse">
      {/* Navbar Spacer */}
      <div className="h-20" />

      {/* Hero Section Skeleton */}
      <div className="bg-[#2A382A]">
        <div className="relative h-[60vh] md:h-[80vh] grid grid-cols-1 md:grid-cols-12 gap-4 p-4 max-w-7xl mx-auto">
          <div className="md:col-span-8 relative overflow-hidden rounded-2xl bg-white/10">
            {/* Price Tag Skeleton */}
            <div className="absolute top-4 right-4 h-8 w-24 bg-white/20 rounded-full" />
          </div>
          <div className="hidden md:col-span-4 md:grid grid-rows-2 gap-4">
            <div className="relative overflow-hidden rounded-2xl bg-white/10" />
            <div className="relative overflow-hidden rounded-2xl bg-white/10" />
          </div>
        </div>
      </div>

      {/* Info Section Skeleton */}
      <section className="bg-white">
        <div className="max-w-5xl mx-auto px-4 py-16 md:px-8">
          <div className="space-y-8">
            <div>
              <div className="h-12 w-2/3 bg-gray-200 rounded-lg mb-4" />
              <div className="h-8 w-1/4 bg-gray-200 rounded-lg" />
            </div>

            <div className="h-px bg-gray-200" />

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
              {[...Array(4)].map((_, i) => (
                <div key={i} className="flex items-center gap-3">
                  <div className="w-12 h-12 bg-gray-200 rounded-lg" />
                  <div className="flex-1">
                    <div className="h-4 w-20 bg-gray-200 rounded mb-2" />
                    <div className="h-6 w-32 bg-gray-200 rounded" />
                  </div>
                </div>
              ))}
            </div>

            <div className="h-px bg-gray-200" />

            <div className="space-y-4">
              <div className="h-8 w-3/4 bg-gray-200 rounded-lg" />
              <div className="space-y-3">
                <div className="h-4 bg-gray-200 rounded w-full" />
                <div className="h-4 bg-gray-200 rounded w-5/6" />
                <div className="h-4 bg-gray-200 rounded w-4/6" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Booking Section Skeleton */}
      <section className="bg-[#F2F3F4]">
        <div className="max-w-5xl mx-auto px-4 py-16 md:px-8">
          <div className="h-10 w-1/3 bg-gray-200 rounded-lg mb-8" />
          <div className="space-y-4">
            {[...Array(3)].map((_, i) => (
              <div key={i} className="bg-white rounded-xl p-6">
                <div className="flex justify-between items-center">
                  <div className="flex items-center gap-4">
                    <div className="w-12 h-12 bg-gray-100 rounded-lg" />
                    <div className="space-y-2">
                      <div className="h-5 w-32 bg-gray-100 rounded" />
                      <div className="h-4 w-48 bg-gray-100 rounded" />
                    </div>
                  </div>
                  <div className="flex items-center gap-4">
                    <div className="space-y-1">
                      <div className="h-6 w-24 bg-gray-100 rounded" />
                      <div className="h-4 w-16 bg-gray-100 rounded" />
                    </div>
                    <div className="w-28 h-10 bg-gray-100 rounded-lg" />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default TourDetailSkeleton;